module.exports = __webpack_public_path__ + "static/media/logo.e5631acb.svg";